import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './RedirectCarryOverModal.module.css';
import redirectIcon from '../../assets/redirect-icon.svg';
import ModalContainer from './ModalContainer';
import { RoundButton } from './RoundButton';
import {
  closeCarryOverModal,
  restartEmployerIdValidation,
} from '../../actions';

export const RedirectCarryOverModal = () => {
  const redirectURL = useSelector(({ quoting }) => quoting.redirectCarryOver);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const handleContinue = useCallback(() => {
    const newUrl = new URL(redirectURL);
    dispatch(restartEmployerIdValidation());

    const isEBRedirect = newUrl.origin === process.env.REACT_APP_EB_URL;

    if (isEBRedirect) {
      dispatch(closeCarryOverModal());
      history.push(`${newUrl.pathname}${newUrl.search}`);
      return;
    }

    window.location.href = redirectURL;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectURL]);

  return (
    <ModalContainer cancelable={false} show={!!redirectURL}>
      <div className={styles.container}>
        <div className={styles.content}>
          <img alt="" src={redirectIcon} />

          <h1 className={styles.title}>{t('redirectCarryOver.title')}</h1>

          <p className={styles.message}>{t('redirectCarryOver.message')}</p>
        </div>

        <RoundButton onClick={handleContinue} primary>
          {t('redirectCarryOver.continue')}
        </RoundButton>
      </div>
    </ModalContainer>
  );
};
